import { render, staticRenderFns } from "./tableSets.vue?vue&type=template&id=5e8cece4&scoped=true&"
import script from "./tableSets.vue?vue&type=script&lang=js&"
export * from "./tableSets.vue?vue&type=script&lang=js&"
import style0 from "./tableSets.vue?vue&type=style&index=0&id=5e8cece4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8cece4",
  null
  
)

component.options.__file = "tableSets.vue"
export default component.exports